module.exports = __webpack_public_path__ + "img/alice margatroid.07fe0501.png";